<template>
  <div>
    <HeaderPurchase header="แก้ไขรายละเอียด" :img_header="header_image" link_back="purchase"/>
    <Purchase_edit/>
  </div>
</template>

<script>
import HeaderPurchase from "@/components/admin/purchase/headerpurchase/HeaderPurchase";
import HeaderImage from "@/assets/compliance.png";
import Purchase_edit from "@/components/admin/purchase/Purchase_edit";

export default {
  name: "PurchaseEdit",
  components: {
    Purchase_edit,
    HeaderPurchase
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>